<div class="spinner-overlay-container" [ngClass]="{ fullSize: fullSize }" *ngIf="inFlight">
  <app-in-flight-spinner [fullSize]="fullSize"></app-in-flight-spinner>
</div>
